import { render, staticRenderFns } from "./FunctionSetting.vue?vue&type=template&id=6211557e&scoped=true"
import script from "./FunctionSetting.vue?vue&type=script&lang=js"
export * from "./FunctionSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6211557e",
  null
  
)

export default component.exports